import { FilterBar } from "@/components/layout/FilterBar";
import { PageHeader } from "@/components/layout/PageHeader";
import { WidgetGrid } from "@/components/dashboard/WidgetGrid";
import { WidgetPicker } from "@/components/dashboard/WidgetPicker";
import { useFilteredAll } from "@/hooks/useFilteredData";
import { useDashboardLayout } from "@/hooks/useDashboardLayout";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { LoadingState } from '@/components/ui/spinner';

export default function DashboardPage() {
  const { fb, ig, ga4, accounts, filters, setFilters, loading } = useFilteredAll();
  const { widgetIds, layouts, onLayoutChange, addWidget, removeWidget, resetLayout, loaded } = useDashboardLayout();

  // Need allData for period comparison in WidgetRenderer
  // Re-fetch from the hook internals - fb/ig/ga4 are already filtered
  // We need unfiltered for previous period comparison

  if (loading || !loaded) return <LoadingState label="Načítám data…" />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <PageHeader title="Přehled" description="Váš vlastní dashboard" />
        <div className="flex gap-2">
          <WidgetPicker activeWidgetIds={widgetIds} onAdd={addWidget} onRemove={removeWidget} />
          <Button variant="outline" size="icon-lg" onClick={() => { resetLayout(); toast.success('Výchozí rozložení widgetů obnoveno'); }} title="Obnovit výchozí rozložení">
            <RotateCcw className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <FilterBar filters={filters} onChange={setFilters} accounts={accounts} />

      <WidgetGrid
        widgetIds={widgetIds}
        layouts={layouts}
        onLayoutChange={onLayoutChange}
        onRemove={removeWidget}
        fb={fb}
        ig={ig}
        ga4={ga4}
        allFb={fb}
        allIg={ig}
        dateFrom={filters.dateFrom}
        dateTo={filters.dateTo}
      />
    </div>
  );
}
